export const getTotalPages = (allData, rowPerPage) => {
  let count = 1

  if (allData && allData.length !== 0) {
    if (allData.length % rowPerPage === 0) {
      count = allData.length / rowPerPage
    } else {
      count = allData.length / rowPerPage + 1
    }
  }
  return count >> 0
}

export const extractDataOfCurrPage = (
  pageNumber,
  allData,
  rowPerPage,
  setDataCallback,
  setPageNumCallback
) => {
  let displayList = []

  if (allData.length > 0) {
    if (allData.length % rowPerPage === 0) {
      for (
        let i = (pageNumber - 1) * rowPerPage;
        i < (pageNumber - 1) * rowPerPage + rowPerPage;
        i++
      ) {
        displayList.push(allData[i])
      }
    } else {
      for (
        let i = (pageNumber - 1) * rowPerPage;
        i < (pageNumber - 1) * rowPerPage + rowPerPage;
        i++
      ) {
        if (i < allData.length) {
          displayList.push(allData[i])
        }
      }
    }

    setDataCallback(displayList)
    setPageNumCallback(pageNumber)
  } else {
    setDataCallback([])
    setPageNumCallback(1)
  }
}
